<template>
    <v-dialog
        v-model="deleteVacationDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ attrs }">
            <v-btn
                v-if="modelType==='DeleteBtn'"
                class="delete-btn"
                outlined
                light
                @click="openDialog"
            >
                Delete
            </v-btn>
            <v-icon
                v-if="modelType==='DeleteIcon'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-delete
            </v-icon>
        </template>
        <v-card id="delete_vacation_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span>Delete</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div class="mt-5">
                    Are you sure you want to delete <b>{{ vacation }}</b> from Vacation list?
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="deleteVacation"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>  
</template>

<script>
export default {
    name: 'DeleteVacation',
    props: {
        modelType: {
            type: String,
            required: true
        },
        vacation: {
            type: String,
            required: true
        }
    },
    data: () => ({
        deleteVacationDialog: false
    }),
    computed: {
        getEditUser() {
            return this.$store.getters.editUser;
        },
    },
    methods: {
        openDialog() {
            this.deleteVacationDialog = true;
        },
        closedDialog() {
            this.deleteVacationDialog = false;
        },
        deleteVacation() {
            this.$emit('delete-vacation',  this.vacation );
            this.closedDialog();
                            
        },
    }

};
</script>

<style>

</style>